import { bool, func, shape, element } from 'prop-types';
import Modal from 'react-modal';

const BaseModal = ({
  isOpen = false,
  onRequestClose,
  shouldCloseOnOverlayClick = true,
  styles,
  children,
}) => {
  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      zIndex: '99999',
      overflowY: 'auto',
      display: 'flex',
      justifyContent: 'center',
    },
    content: {
      position: 'static',
      alignSelf: 'center',
      margin: 'auto',
      ...styles,
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      appElement={document.getElementById('root')}
    >
      {children}
    </Modal>
  );
};

BaseModal.propTypes = {
  isOpen: bool,
  onRequestClose: func.isRequired,
  shouldCloseOnOverlayClick: bool,
  styles: shape({}).isRequired,
  children: element.isRequired,
};

export default BaseModal;
